import moment from 'moment';

export const getMessageOfRecurrence = (event_group: any) => {
  const repeatRule = event_group?.repeat_rule;
  const endDate = moment(repeatRule?.end_date).format('MMM DD, YYYY');
  
  if (repeatRule?.duration === 'Weekly') {
    const days = repeatRule.repeat_on || [];
    const repeatEvery = repeatRule.repeat_every || 1;
    
    // Format day names properly (convert abbreviated to full names if needed)
    const dayNames = days.map((day: string) => {
      const dayMap: { [key: string]: string } = {
        'Mon': 'Monday',
        'Tue': 'Tuesday', 
        'Wed': 'Wednesday',
        'Thu': 'Thursday',
        'Fri': 'Friday',
        'Sat': 'Saturday',
        'Sun': 'Sunday',
        // Also handle full names in case they're already provided
        'Monday': 'Monday',
        'Tuesday': 'Tuesday',
        'Wednesday': 'Wednesday', 
        'Thursday': 'Thursday',
        'Friday': 'Friday',
        'Saturday': 'Saturday',
        'Sunday': 'Sunday'
      };
      return dayMap[day] || day;
    });
    
    if (repeatEvery === 1) {
      // Special case: every week
      if (dayNames.length === 1) {
        // Single day: "Happening every Tuesday"
        return `Happening every ${dayNames[0]}`;
      } else if (dayNames.length === 2) {
        // Two days: "Happening every Tuesday and Thursday"
        return `Happening every ${dayNames.join(' and ')}`;
      } else {
        // Multiple days: "Happening every Monday, Wednesday, and Friday"
        const lastDay = dayNames.pop();
        return `Happening every ${dayNames.join(', ')}, and ${lastDay}`;
      }
    } else {
      // Multiple weeks: "Happening every 2 weeks on Tuesday" or "Happening every 3 weeks on Monday and Wednesday"
      const weekText = repeatEvery === 1 ? 'week' : 'weeks';
      if (dayNames.length === 1) {
        return `Happening every ${repeatEvery} ${weekText} on ${dayNames[0]}`;
      } else if (dayNames.length === 2) {
        return `Happening every ${repeatEvery} ${weekText} on ${dayNames.join(' and ')}`;
      } else {
        const lastDay = dayNames.pop();
        return `Happening every ${repeatEvery} ${weekText} on ${dayNames.join(', ')}, and ${lastDay}`;
      }
    }
  } else {
    // Handle Daily, Monthly, Yearly
    const repeatEvery = repeatRule?.repeat_every || 1;
    let periodText = '';
    
    if (repeatRule?.duration === 'Daily') {
      if (repeatEvery === 1) {
        return `Happening daily`;
      } else {
        periodText = repeatEvery === 1 ? 'day' : 'days';
      }
    } else if (repeatRule?.duration === 'Monthly') {
      if (repeatEvery === 1) {
        return `Happening monthly`;
      } else {
        periodText = repeatEvery === 1 ? 'month' : 'months';
      }
    } else if (repeatRule?.duration === 'Yearly') {
      if (repeatEvery === 1) {
        return `Happening yearly`;
      } else {
        periodText = repeatEvery === 1 ? 'year' : 'years';
      }
    }
    
    return `Happening every ${repeatEvery} ${periodText}`;
  }
};
